import range from "lodash/range";
import type { ReactNode } from "react";
import React from "react";
import { Pagination } from "react-bootstrap";

interface Props {
	itemCount: number;
	itemPerPage: number;
	activePage: number;
	onChange: (page: number, changeType: "next" | "prev" | "pageNumber") => void;
}

const MAX_PAGE_BUTTON_COUNT = 4;

export class Paginator extends React.Component<Props> {
	public render(): ReactNode {
		const { activePage, itemPerPage, itemCount, onChange } = this.props;

		if (!itemCount) {
			return;
		}

		const pageCount = Math.ceil(itemCount / itemPerPage);
		const isFirst = activePage === 1;
		const isLast = activePage === pageCount;

		const from = Math.floor(Math.max(1, activePage - MAX_PAGE_BUTTON_COUNT / 2));
		const to = Math.ceil(Math.min(pageCount, activePage + MAX_PAGE_BUTTON_COUNT / 2));

		return (
			<Pagination className="justify-content-center">
				<Pagination.Prev disabled={isFirst} onClick={() => onChange(activePage - 1, "prev")} />

				{from !== 1 && <Pagination.Ellipsis />}

				{range(from, to + 1).map((index) => (
					<Pagination.Item
						key={index}
						active={activePage === index}
						onClick={() => onChange(index, "pageNumber")}
					>
						{index}
					</Pagination.Item>
				))}

				{to !== pageCount && <Pagination.Ellipsis />}

				<Pagination.Next disabled={isLast} onClick={() => onChange(activePage + 1, "next")} />
			</Pagination>
		);
	}
}
